import React from "react";
import { Link } from "react-router-dom";
import useMyRank, { rankProgress } from "../../../utils/useMyRank";

// Giriş yapan kullanıcının seviyesi ve bir sonraki seviyeye kalan alkış; seviyeler sayfasına götürür.
// variant="sidebar": koyu kenar çubuğu için kompakt; variant="banner": sayfa içi (temanın açık/koyu modu ile uyumlu).
const LevelProgress = ({ variant = "banner", className = "" }) => {
  const rank = useMyRank();
  if (!rank) return null;

  const sidebar = variant === "sidebar";
  const percent = rankProgress(rank);
  const next = rank.next_rank;

  return (
    <div className={className}>
      <Link
        to="/app/seviyeler"
        className={sidebar ? "" : "box"}
        aria-label={`Seviye ${rank.level}, ${rank.name}. Seviyeler sayfasına git`}
        style={{
          display: "block",
          padding: sidebar ? 12 : 16,
          marginBottom: 0,
          borderRadius: 12,
          border: `1px solid ${sidebar ? "rgba(255,255,255,0.1)" : "rgba(128,128,128,0.2)"}`,
          borderLeft: `4px solid ${rank.color}`,
          backgroundColor: sidebar ? "rgba(255,255,255,0.05)" : undefined,
          color: sidebar ? "rgba(255,255,255,0.87)" : "inherit",
          textDecoration: "none",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: sidebar ? 22 : 30, lineHeight: 1 }} aria-hidden="true">
            {rank.icon}
          </span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="text-ellipsis" style={{ fontWeight: 700, fontSize: sidebar ? 13 : 15 }}>
              Seviye {rank.level} · {rank.name}
            </div>
            <div style={{ fontSize: 12, opacity: 0.7 }}>
              {rank.score} alkış{rank.position ? ` · ${rank.position}. sıradasın` : ""}
            </div>
          </div>
          {!sidebar && (
            <span className="btn btn-sm rounded primary hidden-xs-down" style={{ flexShrink: 0 }}>
              Nasıl yükselirim?
            </span>
          )}
        </div>
        <div
          role="progressbar"
          aria-valuenow={Math.round(percent)}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{ height: 6, marginTop: 10, overflow: "hidden", borderRadius: 3, backgroundColor: "rgba(128,128,128,0.25)" }}
        >
          <div style={{ width: `${percent}%`, height: "100%", borderRadius: 3, backgroundColor: rank.color }} />
        </div>
        <div style={{ marginTop: 6, fontSize: 12, opacity: 0.85 }}>
          {next ? (
            <>
              {next.icon} <b>{next.name}</b> seviyesine <b>{next.points_needed}</b> alkış kaldı
            </>
          ) : (
            "En yüksek seviyedesin!"
          )}
        </div>
      </Link>
    </div>
  );
};

export default LevelProgress;
